module.exports = __webpack_public_path__ + "static/media/monkey.506e7328.png";